document.addEventListener('DOMContentLoaded', function() {
    const productList = document.querySelector('.product__media-list');
    const leftArrow = document.querySelector('.left_arrow');
    const rightArrow = document.querySelector('.right_arrow');

    // Scroll by 300px on each click of the arrows
    const scrollAmount = 300;

    // Left arrow functionality (scroll left)
    leftArrow.addEventListener('click', function() {
        productList.scrollBy({
            left: -scrollAmount,
            behavior: 'smooth'
        });
    });

    // Right arrow functionality (scroll right)
    rightArrow.addEventListener('click', function() {
        productList.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
        });
    });
});
